import icons from './icons.json'
// import { dialogLabels as dialogOptions } from '.'

export const flexNeedToKnow = [
	"Your HMO ID contains your member ID you present at the hospital to access care. It's important to keep your ID number handy or written out somewhere , as it is required for treatment at any of the listed hospitals under your plan.",
	"You unlock more benefits when you constantly renew your subscription. If you fail to renew, your benefits reset, and you'll only have access to the initial benefits available from the 1st month when you purchase the plan.",
	'Any treatments, tests, procedures, and benefits not listed are not covered, and we will not bear liability for them.',
	'This is an insurance product and it adheres to standard insurance procedures.',
	'This plan is a periodic subscription that renews automatically for card transactions as long as the registered card is funded. Upon expiry, the payment will be deducted from your registered card or funded wallet.',
	'You can starting using your benefits 24 hours after receiving your HMO ID.',
	'Please note that the plan does not cover certain exclusions.',
	'When you or your staff arrive at any of the hospitals, tell them you are from Hygeia. If you experience any delay, call 09070008899'
]
export const howToGetCoveredHealth = [
	'Purchase the plan, and add your staff to the plan.',
	'Ask the policyholders(your staff) to activate their plan, or do it yourself using your dashboard.',
	'After activation, your e-HMO ID will be automatically generated and sent to the policyholder.',
	'24 hours after activation, your staff can now present their HMO ID at any of the available hospitals under the plan to receive healthcare.'
]
const dialogLabels: BenefitStoreContext[string]['dialogLabels'] = {
	addToPlan: {
		description: 'Select a method to add staff to your existing plan',
		title: 'Add Staff To Plan',
		options: {
			batch: { title: 'Batch Add', description: 'Upload list of staff to add via an excel sheet' },
			manual: { title: 'Manual Add', description: 'Enter staff details to add' }
		}
	},
	removeFromPlan: {
		title: 'Remove staff',
		description: 'Select a method to remove staff',
		options: {
			batch: {
				title: 'Batch Removal',
				description: 'Upload the list of staff to remove via an Excel sheet.'
			},
			manual: {
				title: 'Manual Removal',
				description: 'Select the staff to remove'
			}
		}
	}
}

const config = {
	short_description: 'Unlock access to quality health care.',
	description: 'Flexicare protects you and your staff with quality healthcare at ₦ monthly per person.',
	product_title: 'Unlock access to quality health cover',
	card_label:
		'Enjoy Up to ₦1,000,000 coverage. Access healthcare any day, anytime at mcg_price per staff. Comprehensive and accessible coverage.',
	dialogLabels
}
export const flexicare: Record<'hygeia' | 'bastion', Partial<BenefitStoreContext[string]>> = {
	hygeia: {
		...config,
		short_benefits: {
			'Need To Know': {
				icon: icons.need_to_know,
				isOpen: true,
				value: [
					"Your HMO ID contains the enrollment number you present at the hospital to access care. It's important to have your HMO ID with you, as it is required for treatment at any of the listed hospitals.",
					"You unlock more benefits when you consistently renew your subscription. If you fail to renew, your benefits reset, and you'll only have access to the initial benefits available from the 1st month when you repurchase the plan.",
					'Any treatments, tests, procedures, and benefits not listed are not covered, and we will not bear liability for them.',
					'This is an insurance product and it adheres to standard insurance procedures.',
					'This plan is a periodic subscription that renews automatically for card transactions as long as the registered card is funded. Upon expiry, the payment will be deducted from your registered card or funded wallet.',
					'You can start using your benefits 24 hours after receiving your HMO ID.',
					'Please note that the plan does not cover certain exclusions.',
					'When you or your staff arrive at any of the hospitals under your plan, tell them you are from Hygeia. If you experience any delay, call 09070008899'
				]
			},
			'Total Hospitals': {
				icon: icons.hospital,
				isOpen: false,
				key: 'hospital',
				value: [
					{
						text: 'Your staff gains access to over 1200 hospitals across Nigeria.'
					}
				]
			},
			'Your Business Will Enjoy': {
				icon: icons.business,
				isOpen: false,
				value: [
					'Treatment of everyday illnesses, like malaria and more.',
					'Access to different types of surgeries worth up to ₦100,000.',
					'Coverage for delivery and ante-natal care up to ₦100,000.',
					'A digital HMO ID for each person.'
				]
			}
		},
		allBenefits: {
			dialog: {
				benefits: [
					'General & Specialist Consultations: Covered for treatment of basic medical outpatient and inpatient cases. Limited to O&G, Pediatrician, General Surgeon, Cardiothoracic Surgeon, Neurosurgeon, ENT Surgeon, Urologist, Orthopedic Surgeon, Gastroenterologist, Cardiologist, Neurologist, Nephrologist, Psychiatrist, Neonatologist.',
					'Telemedicine Services: 24/7 access to free chats with doctors and nurses via the app.',
					'Laboratory Tests: Limited coverage for Hematology, Chemistry, Microbiology, and Serology tests.',
					'Admissions and accommodations: covered up to 20 days/annum and covered up to inpatient limit.',
					'Eye Care: Covered up to ₦10,000, eye test and treatment up to ₦5,000, glasses up to ₦5,000 (available once in two years).',
					'Dental Care: Primary dental care covered up to ₦5,000 annually, including routine dental examination and pharmacological treatment. Secondary dental care covered up to ₦10,000 annually, available after Month 4.',
					'Physiotherapy: Covered up to ₦20,000 annually, available after Month 4.',
					'Immunization (0-5 years): Covered for BCG, OPV, and DPT, available after Month 4.',
					'Family Planning: Covered up to ₦7,000 for various contraceptives.',
					'Surgeries: Covered up to ₦100,000 annually, available after Month 7. Includes minor, intermediate, and major surgeries.',
					'Obstetrics Care: Covered up to ₦100,000 for antenatal care and delivery, available after Month 11.',
					'Neonatal Care: Male circumcision and ear piercing covered, available after Month 11.',
					'Renal Care (Dialysis): Covered up to ₦40,000, available after Month 11.',
					'Wellness Checks: Covered for BMI, general physical examination, blood pressure, and diabetes screenings, available after Month 7.',
					'Ambulance Services: Covered for hospital-to-hospital movement up to 4 times per annum.',
					'Psychiatry Care: Covered up to 6 weeks outpatient only.',
					'HIV Care & Treatment: Specialist consultation and drug therapy covered up to pharmacy limit.',
					'Seeking Second Opinion: Covered within HMO network for diagnosis and treatment confirmation.',
					'Mortuary Services: Covered up to ₦40,000 after Month 7 for after-demise care.',
					'Death Cover: Payment up to the stated limit in the event of death, subject to compliance with plan rules.'
				],
				need_to_know: [
					"Your HMO ID contains the enrollment number you present at the hospital to access care. It's important to have your HMO ID with you, as it is required for treatment at any of the listed hospitals.",
					"You unlock more benefits when you consistently renew your subscription. If you fail to renew, your benefits reset, and you'll only have access to the initial benefits available from the 1st month when you repurchase the plan.",
					'Any treatments, tests, procedures, and benefits not listed are not covered, and we will not bear liability for them.',
					'This is an insurance product and it adheres to standard insurance procedures.',
					'This plan is a periodic subscription that renews automatically for card transactions as long as the registered card is funded. Upon expiry, the payment will be deducted from your registered card or funded wallet.',
					'You can start using your benefits 24 hours after receiving your HMO ID.',
					'Please note that the plan does not cover certain exclusions.',
					'When you or your staff arrive at any of the hospitals under your plan, tell them you are from Hygeia. If you experience any delay, call 09070008899'
				],
				'How to get covered': [
					'Purchase the plan and add your staff.',
					'Ask the policyholders (your staff) to activate their plans, or do it yourself from your dashboard.',
					'After activation, the e-HMO ID will be automatically generated.',
					'24 hours after activation, your staff can present their HMO ID at any of the hospitals under the plan to receive healthcare.'
				]
			}
		}
	},
	bastion: {
		...config,
		short_benefits: {
			'Need To Know': {
				icon: icons.need_to_know,
				isOpen: true,
				value: [
					"Your HMO ID contains the enrollment number you present at the hospital to access care. It's important to have your HMO ID with you, as it is required for treatment at any of the listed hospitals.",
					'Any treatments, tests, procedures, and benefits not listed are not covered, and we will not bear liability for them.',
					'This is an insurance product and it adheres to standard insurance procedures.',
					'This plan is a periodic subscription that renews automatically for card transactions as long as the registered card is funded. Upon expiry, the payment will be deducted from your registered card or funded wallet.',
					'You can start using your benefits 24 hours after receiving your HMO ID.',
					'Please note that the plan does not cover certain exclusions.',
					'When you or your staff arrive at any of the hospitals under your plan, tell them you are from Hygeia. If you experience any delay, call 09070008899'
				]
			},
			'Total Hospitals': {
				icon: icons.hospital,
				isOpen: false,
				key: 'hospital',
				value: [
					{
						text: 'Your staff gains access to over 1200 hospitals across Nigeria.'
					}
				]
			},
			'Your Business Will Enjoy': {
				icon: icons.business,
				isOpen: false,
				value: [
					'Treatment of everyday illnesses, like malaria and more.',
					'Access to different types of surgeries worth up to ₦100,000.',
					'Coverage for delivery and ante-natal care up to ₦100,000.',
					'A digital HMO ID for each person.'
				]
			}
		},
		allBenefits: {
			dialog: {
				benefits: [
					'General & Specialist Consultations: Covered for treatment of basic medical outpatient and inpatient cases. Limited to O&G, Pediatrician, General Surgeon, Cardiothoracic Surgeon, Neurosurgeon, ENT Surgeon, Urologist, Orthopedic Surgeon, Gastroenterologist, Cardiologist, Neurologist, Nephrologist, Psychiatrist, Neonatologist.',
					'Telemedicine Services: 24/7 access to free chats with doctors and nurses via the app.',
					'Laboratory Tests: Limited coverage for Hematology, Chemistry, Microbiology, and Serology tests.',
					'Admissions and accommodations: covered up to 14 days/annum and covered up to the inpatient limit.',
					'Eye Care: Covered. Lenses and frames - covered up to ₦5,000.',
					'Dental Care: Primary and secondary dental care covered up to ₦10,000.',
					'Physiotherapy: Covered up to 2 sessions.',
					'Immunization (0-5 years): Covered for BCG, OPV, DPT, measles, and yellow fever.',
					'Family Planning: Covered up to the Family Planning limit of ₦30,000.',
					'Surgeries: Covered up to ₦100,000 annually. Includes minor, intermediate, and major surgeries.',
					'Obstetrics Care: Covered up to ₦100,000 for antenatal care and delivery.',
					'Neonatal Care: Male circumcision and ear piercing covered.',
					'Wellness Checks: Covered for BMI, general physical examination, blood pressure, and diabetes screenings.',
					'Ambulance Services: Covered accident and emergency limit up to ₦100,000.',
					'Psychiatry Care: Covered 2 sessions up to ₦20,000.',
					'HIV Care & Treatment: Specialist consultation and drug therapy covered up to pharmacy limit.',
					'Seeking Second Opinion: Covered within HMO network for diagnosis and treatment confirmation.'
				],
				need_to_know: [
					"Your HMO ID contains the enrollment number you present at the hospital to access care. It's important to have your HMO ID with you, as it is required for treatment at any of the listed hospitals.",
					'Any treatments, tests, procedures, and benefits not listed are not covered, and we will not bear liability for them.',
					'This is an insurance product and it adheres to standard insurance procedures.',
					'This plan is a periodic subscription that renews automatically for card transactions as long as the registered card is funded. Upon expiry, the payment will be deducted from your registered card or funded wallet.',
					'You can start using your benefits 24 hours after receiving your HMO ID.',
					'Please note that the plan does not cover certain exclusions.',
					'When you or your staff arrive at any of the hospitals under your plan, tell them you are from Hygeia. If you experience any delay, call 09070008899'
				],
				'How to get covered': [
					'Purchase the plan and add your staff.',
					'Ask the policyholders (your staff) to activate their plans, or do it yourself from your dashboard.',
					'After activation, the e-HMO ID will be automatically generated.',
					'24 hours after activation, your staff can present their HMO ID at any of the hospitals under the plan to receive healthcare.'
				]
			}
		}
	}
}
